/**
 * VO for sending generic data in xapi statements
 **/
export class StatementDataVO {
	verb: string;
	pageId: string;
	courseName: string;
	courseVersion: string;
	moduleId: string;
	currentLanguage: string;
	statementType: string;
	currentLangCode: string;
	isModule: boolean;
	uniqueId: string;
	courseRevision: string;

	constructor(verb, model?, isModule?) {
		this.verb = verb;
		if (model) {
			this.isModule = isModule ? isModule : false;
			this.courseVersion = model.courseStructureModel.structureDocXml
				.querySelectorAll("course")[0]
				.getAttribute("versionNum");
			this.courseName = model.courseStructureModel.structureDocXml
				.querySelectorAll("course")[0]
				.getAttribute("comment");
			this.pageId = !isModule ? model.courseData.courseModule.page_id : "";
			this.moduleId = model.courseData.courseModule.module_id;
			this.currentLanguage = model.currentLanguage;
			this.currentLangCode =
				model.configDocModelService.availableLanguages.find(
					(x) => x.language == model.currentLanguage
				).langCode;
			this.uniqueId = model.configDocModelService.uniqueId;
			this.courseRevision = model.configDocModelService.courseRevision;
		}
		return this;
	}
}
